

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Spinner } from "react-bootstrap";
import { API_URL } from "..";
import EditAssetLayer from "../components/EditAssetLayer";

const EditAssetPage = () => {
  const { id } = useParams();
  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchAsset = async () => {
    const locationId =  localStorage.getItem('locationID')
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/assets/${id}?locationId=${locationId}`);
      const data = await res.json();

      if (res.ok) {
        setAsset(data.data);
      }
    } catch (error) {
      console.error("Failed to load asset:", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchAsset();
  }, [id]);

  return (
    <MasterLayout>
      <Breadcrumb title="Edit Asset" />

      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}

      {!loading && asset && (
        <EditAssetLayer assetData={asset} />
      )}
    </MasterLayout>
  );
};

export default EditAssetPage;
